import { makeStyles } from "$components/mui-styles";
import classNames from "classnames";
import React from "react";
import { Link, type LinkProps } from "react-router-dom";

const useUnstyledLinkStyles = makeStyles({
  root: {
    color: "inherit",
    textDecoration: "none",
  },
});

const UnstyledLink = React.forwardRef<HTMLAnchorElement, LinkProps>(
  ({ className, ...props }, ref) => {
    const classes = useUnstyledLinkStyles();

    return (
      <Link
        ref={ref}
        className={classNames(classes.root, className)}
        {...props}
      />
    );
  },
);

UnstyledLink.defaultProps = {
  replace: false,
  className: undefined,
};

export default UnstyledLink;
